import React from 'react';
import { ImageBackgroundProps, StyleSheet, View, ViewStyle } from 'react-native';
import { Image } from 'expo-image';

export interface BackgroundImageProps extends Omit<ImageBackgroundProps, 'source'> {
    uri?: string;
    localSource?: any; // For local images using require()
    style?: ViewStyle;
    children?: React.ReactNode;
}

export const BackgroundImage = React.memo<BackgroundImageProps>(function BackgroundImage({
    uri,
    localSource,
    style,
    children,
    ...props
}) {
    // Use expo-image for network images (with caching), fallback to ImageBackground for local images
    if (uri) {
        return (
            <View style={[styles.container, style]} {...props}>
                <Image
                    source={{ uri }}
                    style={StyleSheet.absoluteFill}
                    contentFit="cover"
                    cachePolicy="memory-disk" // Enable both memory and disk caching
                    transition={200} // Smooth fade-in transition
                />
                {children}
            </View>
        );
    }

    // For local images, we still need ImageBackground from react-native
    // as expo-image doesn't support require() directly in the same way
    const { ImageBackground } = require('react-native');
    const source = localSource;

    return (
        <ImageBackground
            source={source}
            style={[styles.container, style]}
            resizeMode="cover"
            {...props}
        >
            {children}
        </ImageBackground>
    );
});

const styles = StyleSheet.create({
    container: {
        flex: 1,
        width: '100%',
        height: '100%',
    },
});

export default BackgroundImage;
